import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthRolService {
  roles = this.authService.getUserRole();
  protected roleGroups: { [key: string]: string[] };
  protected outsideDepartmentRoles = ['Admin', 'Chief'];

  constructor(protected authService: AuthService) {}

  protected lookForRolesNeeded(rols: string[]): boolean {
    let approved = false;
    this.roles.every((rol) => {
      if (rols.find((el) => el === rol)) {
        approved = true;
      }
      return !approved;
    });
    return approved;
  }

  protected onlyViewers(department: string[]): boolean {
    const depUpper = department.map((el) => el.toUpperCase());
    let res = true;
    this.roles.every((rol) => {
      const rolName = rol.toUpperCase();
      if (
        !rolName.includes('VIEWER') &&
        depUpper.find((dep) => rolName.includes(dep))
      ) {
        res = false;
      }
      if (this.outsideDepartmentRoles.includes(rol)) {
        res = false;
      }
      return res;
    });
    return res;
  }

  hasRoleGroup(group: string | string[]): boolean {
    const groupKeys = [...group];
    if (!groupKeys.length) {
      return false;
    }
    for (const groupKey of groupKeys) {
      const groupRoles = this.roleGroups[groupKey];
      if (groupRoles?.length && this.lookForRolesNeeded(groupRoles)) {
        return true;
      }
    }
    return false;
  }
}
